'use client';

import { SimpleGrid } from '@chakra-ui/react';
import { NestedMunicipality } from '@habity/types';
import { NoResults } from './components/NoResults';
import { MunicipalityCard } from '~/components/ui/cards/MunicipalityCard';
import { getMunicipalityPath } from '@habity/services/municipalities';
import { useGridFullRows } from '~/hooks/useGridFullRows';

type MunicipalitiesGridProps = {
  municipalities?: NestedMunicipality[] | null;
  isLoading: boolean;
  setLastElement?: TODO | null;
};

export const MunicipalitiesGrid = ({
  municipalities,
  isLoading,
}: MunicipalitiesGridProps) => {
  // No need for placeholder municipalities as the search page handles skeletons
  const municipalitiesList = municipalities || [];

  const { gridRef, visibleItems: visibleMunicipalities } =
    useGridFullRows(municipalitiesList);

  const actualVisibleMunicipalities =
    municipalitiesList.length === 0 && !isLoading ? [] : visibleMunicipalities;

  if (!actualVisibleMunicipalities || !actualVisibleMunicipalities.length) {
    return <NoResults tab="municipalities" />;
  }

  return (
    <SimpleGrid
      ref={gridRef}
      columns={{ mobile: 1, tablet: 2, desktop: 3 }}
      rowGap="10"
      columnGap="5"
      pb={{ mobile: '12', desktop: '24' }}
      pt="0"
    >
      {actualVisibleMunicipalities.map((municipality, index) => (
        <MunicipalityCard
          key={index}
          href={getMunicipalityPath(municipality)}
          municipality={municipality}
          isLoading={municipality?.loading || false}
        />
      ))}
    </SimpleGrid>
  );
};
